const ROUTE_LABELS: Record<
  string,
  {
    label: string;
    isHidden: boolean;
  }
> = {
  // Root routes
  '/': { label: 'Home', isHidden: false },
  '/dashboard': { label: 'Dashboard', isHidden: false },
  '/privacy-policy': { label: 'Privacy Policy', isHidden: false },
  '/terms-of-use': { label: 'Terms of Use', isHidden: false },
  '/auth/account-settings/privacy-policy': {
    label: 'Privacy Policy',
    isHidden: false,
  },
  '/auth/account-settings/terms-of-use': {
    label: 'Terms of Use',
    isHidden: false,
  },

  // Auth routes
  '/auth': { label: 'Authentication', isHidden: true },
  '/auth/login': { label: 'Login', isHidden: false },
  '/auth/register': { label: 'Register', isHidden: false },
  '/auth/forgot-password': { label: 'Forgot Password', isHidden: false },
  '/auth/verify': { label: 'Verify Account', isHidden: false },
  '/auth/onboarding': { label: 'Onboarding', isHidden: true },

  // Account Settings routes
  '/auth/account-settings': { label: 'Account Settings', isHidden: false },
  '/auth/account-settings-tile': { label: 'Account Settings', isHidden: false },
  '/auth/account-settings/profile': {
    label: 'Personal Information',
    isHidden: false,
  },
  '/auth/account-settings/login-and-security': {
    label: 'Login & Security',
    isHidden: false,
  },
  '/auth/delete-account': {
    label: 'Delete Account',
    isHidden: false,
  },
  '/auth/change-password': {
    label: 'Change Password',
    isHidden: false,
  },
  '/auth/change-email': {
    label: 'Change Email',
    isHidden: false,
  },

  // Help Centre routes
  '/auth/account-settings/help-centre': {
    label: 'Help Centre',
    isHidden: false,
  },
  '/auth/account-settings/help-centre/contact-us': {
    label: 'Contact Us',
    isHidden: false,
  },
  '/auth/account-settings/report-a-problem': {
    label: 'Report a Problem',
    isHidden: false,
  },

  // About routes
  '/auth/account-settings/about': { label: 'About', isHidden: false },

  // Marketplace routes (if using the marketplace layer)
  '/marketplace': { label: 'Marketplace', isHidden: false },
};

export default ROUTE_LABELS;
